/**
 * Builds a human-readable device name from the current browser environment
 * (e.g. "Chrome on macOS"). The browser has no real device identifier, so we
 * derive a stable, recognizable label from the user agent to send on login.
 */
export function getDeviceName(): string {
  if (typeof navigator === 'undefined') {
    return 'frontend';
  }

  const browser = detectBrowser(navigator.userAgent);
  const os = detectOs(navigator.userAgent, navigator.platform);

  return `${browser} on ${os}`;
}

function detectBrowser(userAgent: string): string {
  // Order matters: Edge/Opera/Brave ship "Chrome" in their UA, so check them first.
  if (/\bEdg\//.test(userAgent)) {
    return 'Edge';
  }
  if (/\bOPR\/|\bOpera\b/.test(userAgent)) {
    return 'Opera';
  }
  if (/\bFirefox\//.test(userAgent)) {
    return 'Firefox';
  }
  if (/\bChrome\//.test(userAgent)) {
    return 'Chrome';
  }
  if (/\bSafari\//.test(userAgent)) {
    return 'Safari';
  }
  return 'Browser';
}

function detectOs(userAgent: string, platform: string): string {
  if (/\bWindows\b/.test(userAgent)) {
    return 'Windows';
  }
  if (/\b(iPhone|iPad|iPod)\b/.test(userAgent)) {
    return 'iOS';
  }
  if (/\bAndroid\b/.test(userAgent)) {
    return 'Android';
  }
  if (/\bMac OS X\b|\bMacintosh\b/.test(userAgent) || /^Mac/.test(platform)) {
    return 'macOS';
  }
  if (/\bLinux\b/.test(userAgent)) {
    return 'Linux';
  }
  return 'Unknown OS';
}
